import { Component} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTable } from 'primeng/primeng';
import { ConfirmationService, LazyLoadEvent, Message, SelectItem } from 'primeng/api';
import { InterestsService } from '../../../services/business/interests.service';
import { Interest } from '../../../models/inModels/Interest';
import { AuthenticationService } from '../../../services/authentication/authentication.service';

@Component({
  selector: 'app-interests',
  templateUrl: './interests.component.html',
  styleUrls: ['./interests.component.css']
})
export class InterestsComponent  {
  loading: boolean;
  messages: Message[];
  interests: Interest[];
  rows: SelectItem[];
  error: Message[];
  rowEvent: LazyLoadEvent;
  totalRecords: number;
  filteredRecords: number;
  selectedRows: number;

  constructor(
    private rout: ActivatedRoute,
    private router: Router,
    private interestService: InterestsService,
    private confirmationService: ConfirmationService,
    private auth: AuthenticationService) { 
    
      this.loading = true;
      this.rows = [];
      this.rows.push({ label: '10', value: 10 });
      this.rows.push({ label: '25', value: 25 });
      this.rows.push({ label: '50', value: 50 });
      this.selectedRows = 10;
  }
  changeRows(event): void {
    this.loadInterest(this.rowEvent);
  }
  
  reset(dt: DataTable, gb: HTMLInputElement) {
    gb.value = '';
    dt.reset();
  } 

  loadInterest(event: LazyLoadEvent): void {
    this.loading = true;
    event.rows = this.selectedRows;
    this.rowEvent = event;
    this.interestService.search(event).then(
      dataPager => {
        this.interests = dataPager.Data;
        this.filteredRecords = dataPager.FilteredRecords;
        this.totalRecords = dataPager.TotalRecords;
        this.loading = false;
      },
      error => {
        this.loading = false;
        console.log(error);
        this.interests  = [];
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      }
    );
  }

  edit(interest: Interest) {
		console.log(interest);
		this.router.navigate(['interests/edit', interest.Id]);
	}
  
  delete(interest: Interest) {
		console.log(interest);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete this interest?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.interestService.delete(interest.Id).then(
					result => {
						this.loading = false;
						this.loadInterest(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}



}



// WEBPACK FOOTER //
// ./src/app/components/sales/interests/interests.component.ts